import { render, staticRenderFns } from "./BaseModalImage.vue?vue&type=template&id=4ba1dfca"
import script from "./BaseModalImage.vue?vue&type=script&lang=js"
export * from "./BaseModalImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports